import React from "react";
import { Button as MuiButton, IconButton as MuiIconButton, makeStyles, Tooltip } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 6,
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  outlined: {
    borderColor: theme.palette.divider,
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "rgba(25, 118, 210, 0.04)",
    },
  },
  iconButton: {
    padding: theme.spacing(0.5),
    "& .MuiSvgIcon-root": {
      fontSize: "1.2rem",
    },
  },
  smallIcon: {
    padding: 4,
    "& .MuiSvgIcon-root": {
      fontSize: 14,
    },
  },

  deleteButton: {
    backgroundColor: theme.palette.danger.dark,
    color: theme.palette.danger.contrastText,

    "&:hover": {
      backgroundColor: "#b71c1c",
    },
  },
}));

// ------------------ UI Component ------------------ //
export const SKButton = ({ variant = "text", color = "primary", className = "", ...props }) => {
  const classes = useStyles();

  const btnClasses = [
    classes.root,
    // color === "delete" && classes.deleteButton,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <MuiButton className={btnClasses} variant={variant} color={color} {...props} />;
};

export const SKIconButton = ({ size = "medium", color = "default", className = "", tooltip, ...props }) => {
  const classes = useStyles();

  const iconButtonClasses = [
    classes.iconButton,
    size === "small" && classes.smallIcon,
    // color === "delete" && classes.deleteButton,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const button = <MuiIconButton className={iconButtonClasses} color={color} {...props} />;

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }

  return button;
};

// ------------------ Domain Service Layer ------------------ //
export const SKExportButton = ({
  variant = "text",
  color = "primary",
  className = "",
  onExport,
  label = "Export",
  loadingLabel = "Generating...",
  ...props
}) => {
  const classes = useStyles();
  const [isGenerating, setIsGenerating] = React.useState(false);

  const handleClick = async (e) => {
    if (!onExport) return;

    try {
      setIsGenerating(true);
      await onExport(e);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <SKButton
      className={`${classes.root} ${className}`}
      variant={variant}
      color={color}
      onClick={handleClick}
      disabled={isGenerating || props.disabled}
      {...props}
    >
      {isGenerating ? loadingLabel : label}
    </SKButton>
  );
};
